import React from 'react'
import logo from '../images/logo.png'

export default props => {
    return (
        <img alt="Graficas em SP" {...props} src={logo}></img>
    )
}